module.exports = "<div>\n  <h2>{{name}}</h2>\n  <div class=\"map\" #map></div>\n</div>\n"